import React, { useContext } from "react";
import PlayerProfileContext, { PlayerProfileActions } from "../../contexts/player-profile/player-profile.context";
import { FormColumn4Wide, BestSelect } from "best-common-react";
import RequiredInputWithLabelStyled from "../common/required-input-with-label-styled.component";
import CollapseStyled from "../common/collapse-styled.component";
import UniformInput from "../common/uniform-input.component";

const BaseballInformation = ({}) => {
    const playerProfileContext = useContext(PlayerProfileContext);
    const { player, lookups, userCanEditProfile } = playerProfileContext.state;

    const sideOptions = [
        { value: "Left", label: "Left", id: 0 },
        { value: "Right", label: "Right", id: 1 },
        { value: "Switch", label: "Switch", id: 2 },
    ];

    return (
        <CollapseStyled
            title="Baseball Information"
            startsOpen={true}
            iconAfterTitle={false}
            expandIcon="fa-plus-circle"
            collapseIcon="fa-minus-circle"
            styles={{ borderColor: "#dee5ed" }}
        >
            <div className="row">
                {/* Position */}
                <FormColumn4Wide>
                    <RequiredInputWithLabelStyled
                        name="profile-height-position"
                        label="Position"
                        required={userCanEditProfile}
                        disabled={!userCanEditProfile}
                    >
                        <BestSelect
                            styles={{ singleValue: { color: "#495057" } }}
                            id="profile-height-position"
                            isDisabled={!userCanEditProfile}
                            options={lookups.PRO_PLAYER_POSITIONS}
                            isMulti={false}
                            value={player.playerPosition}
                            onChange={value => {
                                playerProfileContext.dispatchPlayerProfile({
                                    type: PlayerProfileActions.DATA_CHANGED,
                                    value: { playerPosition: value, playerPositionId: value.id },
                                });
                            }}
                        />
                    </RequiredInputWithLabelStyled>
                </FormColumn4Wide>

                {/* Uniform number */}
                <FormColumn4Wide>
                    <RequiredInputWithLabelStyled name="uninum" label="Uniform #" required={false}>
                        <UniformInput
                            style={{ color: "#495057" }}
                            value={player.uniformNumber !== null ? player.uniformNumber : ""}
                            name="uninum"
                            disabled={!userCanEditProfile}
                            onChange={value => {
                                playerProfileContext.dispatchPlayerProfile({
                                    type: PlayerProfileActions.DATA_CHANGED,
                                    value: { uniformNumber: value },
                                });
                            }}
                        />
                    </RequiredInputWithLabelStyled>
                </FormColumn4Wide>

                {/* Bats */}
                <FormColumn4Wide>
                    <RequiredInputWithLabelStyled
                        name="profile-height-bats"
                        label="Bats"
                        required={userCanEditProfile}
                        disabled={!userCanEditProfile}
                    >
                        <BestSelect
                            styles={{ singleValue: { color: "#495057" } }}
                            id="profile-height-bats"
                            options={sideOptions}
                            isDisabled={!userCanEditProfile}
                            value={
                                player.battingSide === ""
                                    ? {}
                                    : { value: player.battingSide, label: player.battingSide }
                            }
                            onChange={value => {
                                playerProfileContext.dispatchPlayerProfile({
                                    type: PlayerProfileActions.DATA_CHANGED,
                                    value: { battingSide: value.value },
                                });
                            }}
                        />
                    </RequiredInputWithLabelStyled>
                </FormColumn4Wide>

                {/* Throws */}
                <FormColumn4Wide>
                    <RequiredInputWithLabelStyled
                        name="profile-height-throws"
                        label="Throws"
                        required={userCanEditProfile}
                        disabled={!userCanEditProfile}
                    >
                        <BestSelect
                            styles={{ singleValue: { color: "#495057" } }}
                            id="profile-height-throws"
                            options={sideOptions}
                            isDisabled={!userCanEditProfile}
                            value={
                                player.throwingSide === ""
                                    ? {}
                                    : { value: player.throwingSide, label: player.throwingSide }
                            }
                            onChange={value => {
                                playerProfileContext.dispatchPlayerProfile({
                                    type: PlayerProfileActions.DATA_CHANGED,
                                    value: { throwingSide: value.value },
                                });
                            }}
                        />
                    </RequiredInputWithLabelStyled>
                </FormColumn4Wide>
            </div>
        </CollapseStyled>
    );
};

export default BaseballInformation;
